<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
$(document).ready(function () {
  var newsletterSuccessPopup = (function () {
    var popup = $('.newsletter-success-modal');
    var close = popup.find('.close');
    var success = popup.find('.success');
    var error = popup.find('.error');
    var overlay = $('.background-overlay');
    close.off('click').on('click', function () {
      popup.fadeOut();
      overlay.hide();
    });
    overlay.off('click').on('click', function () {
      popup.fadeOut();
      overlay.hide();
    });
  })();
  var newURL = location.href.split('?')[0];
  window.history.pushState('object', document.title, newURL);
});